import React, { Component } from 'react'
import { Link } from 'gatsby'
import * as styles from './mutuallink.module.css'

export default class Mutuallink extends Component {

  render() {
    return (
      <div className={styles.mutuallink}>
        <p className='heading' style={{ marginBottom: `20px` }}>相互リンクしているサイト</p>
        <div className={styles.mutuallink_contents}>
          <p>リンク先で相互リンクをまとめています。</p>
          → <Link to={'/mutuallink/'}>相互リンク集</Link>
        </div>
      </div>
    )
  }
}